import React from "react"

const DownloadIcon = ({ color = "#8B909A", size = 18, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
    >
      <path
        d="M13.1426 9V11.6667C13.1426 12.0203 13.0021 12.3594 12.7521 12.6095C12.502 12.8595 12.1629 13 11.8092 13H2.47591C2.12229 13 1.78315 12.8595 1.5331 12.6095C1.28305 12.3594 1.14258 12.0203 1.14258 11.6667V9"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.80859 5.66797L7.14193 9.0013L10.4753 5.66797"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.14258 9V1"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default DownloadIcon
